// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ToggleButton from 'vue-js-toggle-button'
import { HTTP, cloud, cloud2 } from './http.js'
import { eventbus } from './eventbus.js'
import socketio from 'socket.io-client'
import VueSentry from 'vue2-sentry'
import VueGraph from 'vue-graph'

import Chartkick from 'chartkick'
import VueChartkick from 'vue-chartkick'
import Highcharts from 'highcharts'

import VModal from 'vue-js-modal'

const semver = require('semver')

const moment = require('moment')
require('moment/locale/sv')

Vue.config.productionTip = false

Vue.use(ToggleButton)
Vue.use(VueGraph)
Vue.use(require('vue-cookie'))
Vue.use(require('vue-moment'), {
  moment
})
window.Highcharts = Highcharts
Vue.use(VueChartkick, { Chartkick })
Vue.use(VModal)


/*
Vue.use(VueSentry, {
  protocol: 'https', // Optional: default is https
  key: '666a85d52f07450785c278718c3e5446',
  project: 'nexa-bridge-webbgranssnitt'
})
*/

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  data () {
    return {
      data: {
        rooms: [],
        info: {
          version: ''
        },
        nodes: [],
        scenarios: [],
        triggers: [],
        usersettings: {},
        clients: []
      },
      save: {},
      capabilities: require('./capabilities.json'),
      connected: false,
      hasBeenConnected: false,
      tempSaveStore: {}
    }
  },
  created() {
        
    // Här kollar vi först om vi använder molnet, om vi gör det så
    // kollar vi att vi är inloggade, om vi är inloggade så kommer vi
    // hämta all information från Bridgen.
    if (this.isCloud) {
      if (this.loggedIn) {
        this.boot()
      
        // Här kollar vi efter nya Bridgar varje minut så vi kan notifiera
        // användaren om vi hittar någon.
        cloud.get('find')
        .then(res => res.data)
        .then(json => {
          
        })
      }
      // När användaren loggar in får vi detta och då
      // vill vi också hämta eventuella resurser som finns.
      eventbus.$on('login', () => this.boot())
    } else {
      // Vi använde inte molnet, vilket betyder att vi är lokalt på Bridgen så
      // vi kan köra boot() direkt.
      this.boot()
    }
  },

  methods: {
    reconnect () {
      this.openSocketConnections()
    }, 

    setCache (name, data = {}) {
      if (localStorage) {
        const bridgeId = this.bridgeId
        name = `${bridgeId}_${name}`
        localStorage.setItem(name, (typeof data === 'object' ? JSON.stringify(data) : data))
      }
    },

    hasCache (name) {
      if (localStorage) {
        const bridgeId = this.bridgeId
        name = `${bridgeId}_${name}`
        return localStorage.getItem(name)
      }

      return false
    },

    getCache (name) {
      if (localStorage) {
        const bridgeId = this.bridgeId
        name = `${bridgeId}_${name}`
        const string = localStorage.getItem(name)
        return typeof string === 'string' ? JSON.parse(string) : string
      }
      
      return false
    },

    // Vi måste lägga alla funktioner som skall köras vid start i en separat funktion
    // för detta får inte köras direkt om vi använder molnet, då måste vi alltid vänta
    // till användaren faktiskt loggar in.
    boot () {
      let get = ['scenarios', ['info?extended=1', 'info'], 'triggers', 'usersettings', 'clients']
      get.forEach(g => {
        let url = g
        let name = g

        if (Array.isArray(url)) {
          url = g[0]
          name = g[1]
        }

        if (this.hasCache(name)) this.data[name] = this.getCache(name)

        HTTP.get(url)
        .then(res => res.data)
        .then(json => {
          this.setCache(name, json)
          this.data[name] = json
        })
      })



      const parseRoomData = (json, fresh = false) => {
        this.data.rooms = []

        this.data.rooms.push({ id: 0, name: '' })
        this.data.rooms.push({ id: -1, name: '' })
        
        // Här laddar vi ner bilderna och cachar dem så de finns i webbläsaren
        // när användaren går in under rum-vyn, då ser det ut som om det går lite
        // snabbare.
        json.forEach(room => {
          if ('backURL' in room && room.backURL.length) {
            const image = new Image()
            image.src = room.backURL
          }
          
          this.data.rooms.push(room)
        })

        if (fresh) {
          this.setCache('rooms', json)
        }
      }

      if (this.hasCache('rooms')) parseRoomData(this.getCache('rooms'))

      HTTP.get('rooms')
      .then(res => res.data)
      .then(json => parseRoomData(json, true))

      const parseNodeData = (json, fresh = false) => {
        // Skapar en ny array från den vi får
        this.data.nodes = json.map(node => {
          // Ta bort switchBinary om vin har switchLevel
          if ('capabilities' in node && node.capabilities.includes('switchLevel') && node.capabilities.includes('switchBinary')) {
            node.capabilities.splice(node.capabilities.indexOf('switchBinary'), 1)
          }          
          
          node.lastUpdated = new Date()
          return node
        })

        if (fresh) this.setCache('nodes', json)
      }

      this.hasCache('nodes') && parseNodeData(this.getCache('nodes'))


      // Hämta enheter och spara dessa
      HTTP.get('nodes?field=lastEvents')
      .then(res => res.data)
      .then(json => parseNodeData(json, true))

      this.openSocketConnections()
    },

    async openSocketConnections () {
      /*
        Om vi är på molnet så måste vi "logga in" på socketen för
        att kunna få uppdateringar på Bridgen, det gör vi här nedanför.
      */
      if (this.isCloud) {
        //const upgraded = (await cloud.get('upgraded/' + this.$cookie.get('bridgeId'))).data.upgraded
        //if (upgraded) {
        let url = 'https://api.nexabridge.se:10443/'
        //}        
        
        const cloudSocketConnection = socketio(url, {
          transports: ['websocket'],
          secure: true
        })
        
        cloudSocketConnection.on('connect', () => {
          /*
            Vi emiterar ut att vi vill logga in med ett e-post och lösenord
            samt skickar med de bridgar vi vill få tillgång till. Om användaren då
            har tillgång till dessa kommer live-uppdateringarna att skickas ut.
          */
          cloudSocketConnection.emit('login', {
            user: this.$cookie.get('email'),
            password: this.$cookie.get('password'),
            bridges: [this.$cookie.get('bridgeId')]
          }, (data) => {
            if (data.loginOK && !data.failedBridges.length) {
              this.connected = true
              this.hasBeenConnected = true
            }
          })
        })

        /**
          Alla inkommande händelserna från servern sker med "event" som namn
          och datan från bridge finns i payloaden
        */
        cloudSocketConnection.on('event', (payload) => {
          let p = payload
          if (payload.includes(':null')) {
            p = payload.replace(':null', '').trim()
          }

          this.handleSocketData(p)
        })

        /**
          Om vi av någon anledning kopplar från socketen så sparar vi detta här
          och markerar oss som inte anslutna.
        */
        cloudSocketConnection.on('disconnect', () => this.connected = false)
      } else {
        let localSocketConnection = new WebSocket('ws://' + window.location.hostname + ':8887')
  
        localSocketConnection.onopen = () => {
          this.connected = true
          this.hasBeenConnected = true
        }
        
        localSocketConnection.onclose = () => this.connected = false
        localSocketConnection.onmessage = (data) => this.handleSocketData(data.data)
      }
    },
    
    handleSocketData (msg) {
      // Detta betyder att det finns JSON-data med i meddelandet så då
      // måste vi försöka parsa ut detta.
      if (msg.includes(':')) {
        const parts = msg.split(':')
        const name = parts[0]
        const string = msg.replace(name + ':', '')
        const json = JSON.parse(string)        

        eventbus.$emit(name, json)

        // Det är en nod som körs så detta resulterar i att vi försöker
        // uppdatera statusen på enheten och också skickar ut ett event
        // för ndoen
        if ('sourceNode' in json) {
          const sourceNode = json.sourceNode
          const capability = json.name
          const value = json.value

          const node = this.data.nodes.find(node => node.id === sourceNode)

          // Kolla så att noden finns innan vi försöker uppdatera den
          if (node) {
            eventbus.$emit('nodeEvent', json)
            eventbus.$emit(node.id.toString(), json)

            const cap = this.capabilities[capability]
            
            let updatedValue = {}
            
            if (!(capability in node.lastEvents)) {
              updatedValue = {
                value: null,
                time: null,
                lastUpdated: null,
                fresh: false
              }
            }

            updatedValue.value = value
            updatedValue.time = new Date()

            this.$set(node.lastEvents, capability, updatedValue)
          }
        }
      } else {
        eventbus.$emit(msg)
      }
    },

    removeNode (id) {
      const index = this.data.nodes.findIndex(node => node.id === id)
      if (index) {
        this.data.nodes.splice(index, 1)
      }
    },

    reloadNodes () {
      HTTP.get('nodes?field=lastEvents')
      .then(res => res.data)
      .then(json => {
        // Skapar en ny array från den vi får
        this.data.nodes = json.map(node => {
          node.lastUpdated = new Date()
          return node
        })
      })
    },
    
    isVersionGte (version) {
      if (semver.valid(this.data.info.version)) {
        return semver.gte(this.data.info.version, version)
      }
      return false
    }
  },

  computed: {
    bridgeId () {
      return this.$cookie.get('bridgeId')
    },
    
    // Om vi är anslutna över molnet
    isCloud () {
      const clouds = ['bridge.nexa.se', 'web.nexa.se', 'web.nexabridge.se']
      if (window.location.port === '8181') return true
      return clouds.includes(window.location.hostname)
    },
    
    gotNXT () {
      return ('systemType' in this.data.info && this.data.info.systemType !== 'Bridge1')
    },

    bridge2 () {
      return this.gotNXT
    },

    isNX2 () {
      if ('version' in this.data.info) {
        const [ major ] = this.data.info.version.split('.')
        return major >= 2
      }
      return false
    },
    
    updateAvailable () {
      if ('web' in this.data.usersettings) {
        if ('disableUpdateCheck' in this.data.usersettings.web && this.data.usersettings.web.disableUpdateCheck) {
          return false
        }
      }

      // Kolla så att "lastAvailableVersion" finns i info-objektet och om den
      // gör det kollar vi om Bridgen behöver uppdateras på något sätt.
      return 'lastAvailableVersion' in this.data.info && (this.data.info.version !== this.data.info.lastAvailableVersion)
    },
    
    /**
      Vi anser att vi är inloggade när vi har vissa kakor satta. Om användaren inte har tillgång
      till den Bridge som är satt så kommer han att få ett felmeddelande... till slut.
    */
    loggedIn () {
      if (this.$cookie.get('bridgeId') && this.$cookie.get('hash') && this.$cookie.get('password') && (this.$cookie.get('email') && this.$cookie.get('email') === 'X')) {
        return true
      }
      
      return false
    }
    
    
    
    
    
    
    
    
  }
})



// WEBPACK FOOTER //
// ./src/main.js